import "./MenuSidebar.scss";
import Offcanvas from "react-bootstrap/Offcanvas";
import { NavLink, useNavigate } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { PrimaryBtn } from "../index";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { IoMdArrowForward } from "react-icons/io";
import { paths } from "../../utils/paths";
import Accordion from "react-bootstrap/Accordion";
import { TfiAngleDown } from "react-icons/tfi";
import useExecuteContext from "../../utils/hooks/executeContext";

const MenuSidebar = () => {
  const { menuStatus, setMenuStatus, setShowContact, projects } =
    useExecuteContext();
  const navigate = useNavigate();
  return (
    <Offcanvas
      show={menuStatus}
      onHide={() => {
        setMenuStatus(false);
      }}
      className="menu_side_bar"
    >
      <Offcanvas.Body>
        <div className="top_line">
          <button
            type="button"
            className="close"
            onClick={() => setMenuStatus(false)}
          >
            <IoMdClose />
          </button>

          <PrimaryBtn
            theme="dark"
            title="inquire now"
            clickHandler={() => {
              setMenuStatus(false);
              setShowContact(true);
            }}
          />
        </div>

        <div className="link_grid">
          <div className="link_col">
            <NavLink to={paths.HOME}>
              <IoMdArrowForward /> Home
            </NavLink>
            <NavLink to={paths.ABOUT}>
              <IoMdArrowForward /> About
            </NavLink>
            <NavLink to={paths.EVENTS}>
              <IoMdArrowForward /> Events
            </NavLink>
            <NavLink to={paths.LOCATION}>
              <IoMdArrowForward /> Locations
            </NavLink>

            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Projects <TfiAngleDown />
                </Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="0" className="bg">
                      <Accordion.Header>
                        Ongoing <TfiAngleDown />
                      </Accordion.Header>
                      <Accordion.Body>
                        {projects
                          ?.filter(
                            (ele) =>
                              ele?.project_category === "Builder" &&
                              ele?.category?.name === "Ongoing"
                          )
                          ?.map((data, k) => {
                            return (
                              <NavLink
                                to={`/project/${data?.slug}`}
                                onClick={() => {
                                  setMenuStatus(false);
                                }}
                                key={k}
                              >
                                <IoMdArrowForward /> {data?.name}
                              </NavLink>
                            );
                          })}

                        <NavLink
                          to="/projects/Builder?category=Ongoing"
                          onClick={() => {
                            setMenuStatus(false);
                          }}
                        >
                          <IoMdArrowForward />
                          Know more +
                        </NavLink>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1" className="bg">
                      <Accordion.Header>
                        Upcoming <TfiAngleDown />
                      </Accordion.Header>
                      <Accordion.Body>
                        {projects
                          ?.filter(
                            (ele) =>
                              ele?.project_category === "Builder" &&
                              ele?.category?.name === "Upcoming"
                          )
                          ?.map((data, l) => {
                            return (
                              <NavLink
                                to={`/project/${data?.slug}`}
                                onClick={() => {
                                  setMenuStatus(false);
                                }}
                                key={l}
                              >
                                <IoMdArrowForward /> {data?.name}
                              </NavLink>
                            );
                          })}
                        <NavLink
                          to="/projects/Builder?category=Upcoming"
                          onClick={() => {
                            setMenuStatus(false);
                          }}
                        >
                          <IoMdArrowForward />
                          Know more +
                        </NavLink>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2" className="bg">
                      <Accordion.Header>
                        Delivered <TfiAngleDown />
                      </Accordion.Header>
                      <Accordion.Body>
                        {projects
                          ?.filter(
                            (ele) =>
                              ele?.project_category === "Builder" &&
                              ele?.category?.name === "Delivered"
                          )
                          ?.map((data, l) => {
                            return (
                              <NavLink
                                to={`/project/${data?.slug}`}
                                onClick={() => {
                                  setMenuStatus(false);
                                }}
                                key={l}
                              >
                                <IoMdArrowForward /> {data?.name}
                              </NavLink>
                            );
                          })}
                        <NavLink
                          to="/projects/Builder?category=Delivered "
                          onClick={() => {
                            setMenuStatus(false);
                          }}
                        >
                          <IoMdArrowForward />
                          Know more +
                        </NavLink>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <NavLink to={paths.PROJECTSCONTRACTOR}>
              <IoMdArrowForward /> As a Contractor
            </NavLink>

            <NavLink to={paths.CONTACT}>
              <IoMdArrowForward /> Contact
            </NavLink>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MenuSidebar;
